export enum ButtonBehaviourTypesEnum {
  Submit = 'submit',
  Button = 'button',
  Reset = 'reset',
}
